// extracted by mini-css-extract-plugin
export default {"cls1":"NewsInteractionBar-cls1__b2c57417ae5fb81fb454","cls2":"NewsInteractionBar-cls2___fb57e1fa3de35732a46 NewsInteractionBar-cls1__b2c57417ae5fb81fb454"};